import React from 'react';
import {IonIcon, IonModal, IonButton} from "@ionic/react";
import {alertCircleOutline} from "ionicons/icons";
import ActionButton from "./ActionButton";
import styles from './ConfirmationAlert.module.css';

export interface ConfirmationAlertProps {
  isOpen: boolean;
  onDidDismiss: () => void;
  messages: string[];
  onConfirm: () => void;
  isLoading?: boolean;
  icon?: string;
  cancelLabel?: string;
  confirmLabel?: string;
}

const ConfirmationAlert: React.FC<ConfirmationAlertProps> = (props) => {
  const isLoading = props.isLoading || false;
  const {messages, isOpen, onConfirm, onDidDismiss, icon, cancelLabel, confirmLabel} = props
  return (
    <IonModal
      className={styles.modal}
      isOpen={isOpen}
      onDidDismiss={onDidDismiss}
      backdropDismiss={false}
    >
      <div className="py-8 px-6 flex flex-col h-full">
        <div className="flex justify-center items-center gap-4">
          <div>
            <IonIcon
              icon={icon || alertCircleOutline}
              // style={{color: 'var(--ion-color-dark-contrast)'}}
              size="large"
            />
          </div>
          <div className="text-xl font-bold">
            Atenção!
          </div>
        </div>

        <div className="mt-4 text-center text-pal-dark flex-grow flex flex-col gap-4">
          {messages.map((message, index) => (
            <div key={`alert-message-${index}`}>
              {message}
            </div>
          ))}
        </div>

        <div className="flex justify-center -mx-2">
          <div className="px-2 w-1/2">
            <IonButton
              // className={styles.btCancelar}
              onClick={onDidDismiss}
              expand="full"
              color="secondary"
              disabled={isLoading}
            >
              {cancelLabel || 'Cancelar'}
            </IonButton>
          </div>

          <div className="px-2 w-1/2">
            <ActionButton
              color="primary"
              onClick={onConfirm}
              expand="full"
              loading={isLoading}
            >
              {confirmLabel || 'Prosseguir'}
            </ActionButton>
          </div>
        </div>
      </div>
    </IonModal>
  );
}

export default ConfirmationAlert;
